export default __webpack_public_path__ + "static/grains-b12001f294df94741e34366a4c95c3b8.svg";